export default __webpack_public_path__ + "static/media/ActiveCampaign Logo_Blue_Reverse.7d3854ea.jpg";